import React from 'react';
import { Helmet } from 'react-helmet-async';
import { trackEvent, EventTypes, EventNames } from '@brighterion/insights';

type Head = {
    title: string;
    description: string;
};

type PageElementProps = React.PropsWithChildren<{
    head?: Partial<Head>;
}>;

const PageElement = ({ children, head }: PageElementProps) => {
    React.useEffect(() => {
        trackEvent({
            eventType: EventTypes.track,
            eventName: EventNames.pageView,
            payload: {
                clickIdentifier: head?.title || 'Rules Management'
            }
        });
    }, [head]);

    /** Creating a Page title from the pathname. This is a temp solution! */
    const generateHeadTitle = (path?: string) => {
        if (path) {
            const titles = path.split('/').filter(Boolean);
            const transformStringArray = titles.map((title) => {
                const titleToUpperCase = title.charAt(0).toUpperCase() + title.slice(1);
                return titleToUpperCase.replace(/-/g, ' ');
            });
            return transformStringArray;
        }
        return [path];
    };

    return (
        <>
            <Helmet>
                <title>{head?.title && `${generateHeadTitle(head?.title).join(' - ')} - Rules Management`}</title>
                <meta name='description' content={head?.description ?? 'A Mastercard app'} />
                <link rel='canonical' href={window.location.origin + window.location.pathname} />
            </Helmet>
            {children}
        </>
    );
};

export default PageElement;
